import React, {Component} from 'react';
import {Field} from 'formik';
import {parsers} from '@neosvoc/nv-platform-core-common';
import MultipleChoiceBatteryField from './MultipleChoiceBatteryField';

class MultipleChoiceBatteryType extends Component {
    constructor(props) {
        super(props);
        this.validate = this.validate.bind(this);
    }

    validate(value) {
        try {
            parsers.multipleChoiceBattery(value, this.props);
        } catch (err) {
            return err.payload;
        }
    }

    render() {
        const {id, rows, choices, value} = this.props;
        return (
            <Field name={id} id={id} rows={rows} choices={choices} value={value} component={MultipleChoiceBatteryField} validate={this.validate} />
        );
    }
}

export default MultipleChoiceBatteryType;
